import React from "react";
import { YMaps, Map, Placemark } from "@pbe/react-yandex-maps";

const YandexMap = () => {
  return (
    <YMaps>
      <div style={{ width: "100%", height: "400px" }}>
        <Map
          defaultState={{ center: [51.20118319569682, 51.37321622671725], zoom: 18 }} 
          width="100%"
          height="100%"
        >
          <Placemark geometry={[51.20118319569682, 51.37321622671725]} /> {/* Точка на карте */}
        </Map>
      </div>
    </YMaps>
  );
};

export default YandexMap;